import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { NAVIGATE_TO } from "../../constants/FileConstants";

export default function CustomBreadCrumbs({ breadcrumbs }) {
  const navigate = useNavigate();
  const backToDocumentation = (category) => {
    const id = `#${category.toLowerCase().split(" ").join("-")}-section`;
    navigate(`${NAVIGATE_TO.DOCUMENTATION}${id}`);
  };
  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs.map((crumb, idx) => {
          return idx === breadcrumbs.length - 1 ? (
            <Typography
              key="3"
              color={idx === breadcrumbs.length - 1 ? "gray" : "#1f3a87"}
              padding={0}
            >
              {crumb}
            </Typography>
          ) : (
            <Typography
              style={{ color: "#1f3a87", cursor: "pointer" }}
              onClick={(e) => backToDocumentation(crumb)}
            >
              {crumb}
            </Typography>
          );
        })}
      </Breadcrumbs>
    </Stack>
  );
}
